module.exports = __webpack_public_path__ + "dojoToolkit.2egynV9t.png";